import React from 'react';
import type { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Icon from 'tbk-components/src/components/Icon';
import type { IImage } from 'tbk-components/src/components/Image';
import Nav, { NavItem } from 'tbk-components/src/components/Nav';
import { OffcanvasButton } from 'tbk-components/src/components/Offcanvas';
import Offcanvas from './Offcanvas';
import HeroBanner from '../HeroBanner';
import SearchTool from '../SearchTool';

export interface IMainHeroBannerProps extends IBaseElementProps {
	heading?: string;
	image?: IImage;
	mobileImage?: IImage;
	buttonLabel?: string;
	navItems?: NavItem[];
}

/**
 * Main Hero Banner
 * @block
 * @requiresHooks
 */

const MainHeroBanner: React.FC<IMainHeroBannerProps> = ({
	heading,
	image,
	mobileImage,
	buttonLabel = 'I want to...',
	navItems,
}) => (
	<>
		<HeroBanner
			image={image}
			mobileImage={mobileImage}
			classNames={['hero-banner--main']}
			isMainBanner
			showLogo
		>
			{heading && <h1 className="hero-banner__heading">{heading}</h1>}
			<OffcanvasButton
				className="offcanvas-button"
				target=".offcanvas-main"
			>
				{buttonLabel} <Icon name="plus" />
			</OffcanvasButton>
		</HeroBanner>
		<Offcanvas classNames={['offcanvas-main']} position="top">
			<div className="offcanvas-body">
				<Nav
					classNames={['offcanvas-body__nav-wrapper']}
					navItems={navItems}
					vertical
				/>
			</div>
			<div className="offcanvas-footer">
				<div className="offcanvas-footer__search-wrapper">
					<SearchTool />
				</div>
			</div>
		</Offcanvas>
	</>
);

export default MainHeroBanner;
